import React, { FunctionComponent, useState } from "react";
import { Aside, ButtonProps, CommandBarButton } from "sprint-common-web";

import { ContentSubtype } from "../../../../common/types/ContentSubtype";
import { MovieContentSubtype } from "../../../../common/types/MovieContentSubtype";
import { CreateMovieForm } from "../create-movie-form/CreateMovieForm";
import { MovieItem } from "../MovieItem";

export interface AddMovieCommandBarButtonProps extends ButtonProps {
    contentType: MovieContentSubtype;
    items: MovieItem[];
    pageSize: number;
    setItems(items: MovieItem[]): void;
}

export const AddMovieCommandBarButton: FunctionComponent<AddMovieCommandBarButtonProps> = (
    props: AddMovieCommandBarButtonProps
) => {
    const { contentType, items, pageSize, disabled, setItems } = props;

    const [isSidebarDisplayed, setIsSidebarDisplayed] = useState<boolean>(false);

    const closeSidebar = () => {
        setIsSidebarDisplayed(false);
    };

    const openSidebar = () => {
        setIsSidebarDisplayed(true);
    };

    const handleFormSubmit = (newItem: MovieItem) => {
        closeSidebar();

        if (items.length >= pageSize) items.pop();
        setItems([newItem, ...items]);
    };

    return (
        <>
            <CommandBarButton onClick={openSidebar} text="Add" icon="Add" disabled={disabled} />
            <Aside
                isOpen={isSidebarDisplayed}
                type="form"
                headerText={resolveContentHeader(contentType)}
                onDismiss={closeSidebar}
            >
                <CreateMovieForm contentType={contentType} onCancel={closeSidebar} onSubmit={handleFormSubmit} />
            </Aside>
        </>
    );
};

const resolveContentHeader = (movieContentType: MovieContentSubtype) => {
    const contentHeaders: Record<MovieContentSubtype, string> = {
        [ContentSubtype.Movie]: "Add Movie",
        [ContentSubtype.TvSingle]: "Add TV Single",
        [ContentSubtype.FeatureDocumentary]: "Add Feature Documentary",
        [ContentSubtype.ShortFilm]: "Add Short Film"
    };

    return contentHeaders[movieContentType];
};
